// extracted by mini-css-extract-plugin
export var standaloneTable = "_eu-0";
export var withExtraHeader = "_eu-1";